import { useEffect, useState } from 'react';
import request from 'superagent';

const useLicenseValidator = (org, user) => {
  const { orgID } = org;
  const { userID, accessToken } = user;
  const [license, setLicense] = useState(null);

  useEffect(() => {
    const validateLicense = async () => {
      const REQUEST = `${process.env.NEXT_PUBLIC_INVOICE_API}license?orgID=${orgID}&userID=${userID}&accessToken=${accessToken}`;
      try {
        const res = await request.get(REQUEST);
        if (res && res.body) {
          setLicense(res.body);
        } else {
          setLicense(false);
        }
      } catch (error) {
        console.error('License validation failed', error);
        setLicense(false);
      }
    };

    if(org!==undefined && userID!==undefined && accessToken!==undefined){
      validateLicense();
    }

  }, [orgID, userID, accessToken]); 

  return license; 
};

export default useLicenseValidator;